/* Un message bref, en bas de l'écran, qui dit ce qui vient d'être enregistré.
   Un seul à la fois : le dernier remplace le précédent. */

import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import type { ReactNode } from "react";

const Ctx = createContext<(message: string) => void>(() => undefined);

export function FournisseurToast({ children }: { children: ReactNode }) {
  const [message, setMessage] = useState<string | null>(null);
  const minuteur = useRef<number | undefined>(undefined);

  const montrer = useCallback((m: string) => {
    setMessage(m);
    window.clearTimeout(minuteur.current);
    minuteur.current = window.setTimeout(() => setMessage(null), 4500);
  }, []);

  useEffect(() => () => window.clearTimeout(minuteur.current), []);

  return (
    <Ctx.Provider value={montrer}>
      {children}
      {message ? (
        <div className="toast" role="status" aria-live="polite">
          {message}
        </div>
      ) : null}
    </Ctx.Provider>
  );
}

export function useToast(): (message: string) => void {
  return useContext(Ctx);
}
